import { bindActionCreators } from 'redux';
import { mapValues, pick } from 'lodash';
import { parse } from 'papaparse';
import moment from 'moment';
import 'moment/locale/fi';

// TODO: Dynamically load locales?
const locale = 'fi';

export const dateFormat = moment.localeData(locale).longDateFormat('l');
export const fixedDateFormat = moment.localeData(locale).longDateFormat('L');

export const parseDate = value => {
  if (!value.length) return '';
  const date = moment.utc(value, 'l', locale, true);
  return date.isValid() ? date.format(moment.HTML5_FMT.DATE) : null;
};

export const formatDate = (value, options = {}) => {
  if (!value) return value;
  if (!value.length) return '';
  const { width } = options;
  const format = width === 'fixed' ? fixedDateFormat : dateFormat;
  return moment.utc(value, moment.HTML5_FMT.DATE, locale, true).format(format);
};

export const bickActions = (ops, keys, dispatch) =>
  mapValues(pick(ops, keys), op => bindActionCreators(op, dispatch));

export const formatName = ({ givenName = '', familyName }) => {
  const parts = [...(familyName ? [familyName] : []), givenName];
  parts[0] = parts[0].toUpperCase();
  return parts.join(' ');
};

export const parseCsv = csvString => {
  const options = {
    header: true,
    skipEmptyLines: true,
  };

  const { data } = parse(csvString, options);

  return data;
};

export const joinPath = (first, second) =>
  second.length
    ? first.endsWith('/')
      ? first + second
      : [first, second].join('/')
    : first;



// WEBPACK FOOTER //
// ./src/common.js